import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quanping",
  "use": "icon-quanping-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-quanping\"><path d=\"M291.82558815 822.0684642H380.19940126v110.46726541H104.03123579v-276.16816418h110.4672667v88.37381311l165.70089877-165.70089877 77.32708566 77.32708566-165.70089877 165.70089877z m447.39242667 0l-165.70089876-165.70089877 77.32708565-77.32708566 171.22426249 171.2242612V656.36756543h110.46726541v276.16816418h-276.16816418v-110.46726541h82.85044939zM291.82558815 214.49850249l165.70089877 165.70089877-77.32708566 77.32708566-165.70089877-165.70089877V380.19940126H104.03123579V104.03123579h276.16816547v110.4672667H291.82558815z m447.39242667 0H656.36756543V104.03123579h276.16816418v276.16816547h-110.46726541V286.30222442l-171.22426249 171.2242625-77.32708565-77.32708566 165.70089876-165.70089877z\" p-id=\"2513\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/quanping.svg
// module id = d2Oy
// module chunks = 30